import { createReducer, on } from '@ngrx/store';
import { AuthUser, FieldAccess, ModuleAccess } from '@core/models/user.model';
import { isAdminRole } from '@core/models/roles';
import { AuthActions } from './auth.actions';

export interface AuthState {
  token: string | null;
  user: AuthUser | null;
  moduleAccess: ModuleAccess[];
  fieldAccess: FieldAccess[];
  isAdmin: boolean;
  loading: boolean;
  error: string | null;
}

export const initialAuthState: AuthState = {
  token: null,
  user: null,
  moduleAccess: [],
  fieldAccess: [],
  isAdmin: false,
  loading: false,
  error: null
};

export const authReducer = createReducer(
  initialAuthState,
  on(AuthActions.login, (state) => ({ ...state, loading: true, error: null })),
  on(AuthActions.loginSuccess, (_state, { token, user }) => {
    const rawUser = user as any;
    const moduleAccess: ModuleAccess[] = rawUser?.moduleAccess ?? [];
    const fieldAccess: FieldAccess[]   = rawUser?.fieldAccess  ?? [];
    // Acceso total (no se filtra el menú ni los permisos de campo). La regla
    // vive en `@core/models/roles` porque también la necesitan el meta-reducer
    // de rehidratación y `AuthService.isAdmin()`, y tenerla copiada llevó a que
    // divergieran.
    const isAdmin = isAdminRole(rawUser?.idRole);
    return { token, user, moduleAccess, fieldAccess, isAdmin, loading: false, error: null };
  }),
  on(AuthActions.loginFailure, (state, { error }) => ({ ...state, loading: false, error })),
  on(AuthActions.setModuleAccess, (state, { moduleAccess }) => ({ ...state, moduleAccess })),
  on(AuthActions.logout, () => initialAuthState)
);
